/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const itRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Richiesta di aggiunta scuola',
    description: 'Per favore compila il seguente modulo. Non è garantito che le scuole inviate vengano aggiunte, ma tutte le richieste sono controllate e considerate da SheerID. ',
    noCountry: 'Non vedi il paese della tua scuola? Non sei idoneo a questa offerta',
    searchByOrgName: 'Non vedi la tua scuola? Cerca per nome',
    completeRequest: 'Non vedi la tua scuola nella lista di scuole idonee o non idonee? Completa la tua richiesta',
    submit: 'Invia',
    eligibleOrgs: 'Scuola idonee. Fai click sull’icona per copiare il nome e tornare al modulo di verifica',
    ineligibleOrgs: 'Scuole non idonee. Ci dispiace, gli studenti di queste scuole non sono idonei a questa offerta',
    none: 'Nessuna',
    country: 'Che scuola hai frequentato?',
    changeLanguage: 'Cambia lingua',
    copied: 'Copiato',
    firstName: 'Nome',
    lastName: 'Cognome',
    emailAddress: 'E-mail',
    poweredBy: 'Servizi di verifica forniti da SheerID',
    fields: {
        countryPlaceholder: 'Seleziona Paese',
        domainLabel: 'Sito web della scuola',
        domainPlaceholder: 'www.miascuola.it',
        orgNameLabel: 'Nome scuola',
        orgNamePlaceholder: 'La mia scuola',
    },
    step: {
        success: {
            title: 'Grazie',
            description: 'La tua richiesta di aggiunta di un istituto didattico è stata ricevuta. Tieni presente che potrebbero essere necessari fino a 7 giorni per esaminarla e non è possibile garantire che l\'istituto verrà aggiunto all\'elenco degli istituti didattici idonei per l\'accesso didattico ai prodotti Autodesk.<br><br>Nel frattempo, puoi esplorare le opzioni di abbonamento alternative.',
        },
        error: {
            title: 'Si è verificato un errore inaspettato',
            description: 'Ci dispiace, non siamo riusciti a elaborare la tua richiesta. Prova di nuovo.',
            seeingProblem: 'Se questo errore continua a verificarsi',
            contactUs: 'contattaci',
        },
    },
    errorId: {
        invalidCountry: 'Campo obbligatorio',
        invalidEmail: 'Email non valida',
        invalidFirstName: 'Nome non valido',
        invalidLastName: 'Cognome non valido',
        requiredField: 'Campo obbligatorio',
        invalidField: 'Campo non valido',
        invalidUrl: 'URL non valido',
        tooManyResults: 'La tua richiesta ha restituito troppi risultati, affina la tua ricerca e prova di nuovo',
    },
    faq: 'SheerID FAQ Richiesta Aggiunta Scuola',
    countries: {
        AD: 'Andorra',
        AE: 'Emirati Arabi Uniti',
        AF: 'Afghanistan',
        AG: 'Antigua e Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Antille Olandesi',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'Samoa Americane',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Azerbaijan',
        BA: 'Bosnia ed Erzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgio',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei',
        BO: 'Bolivia',
        BR: 'Brasile',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Isola Bouvet',
        BW: 'Botswana',
        BY: 'Bielorussia',
        BZ: 'Belize',
        CA: 'Canada',
        CD: 'Repubblica Democratica del Congo',
        CF: 'Repubblica Centrafricana',
        CG: 'Congo',
        CH: 'Svizzera',
        CI: 'Costa d\'Avorio',
        CK: 'Isole Cook',
        CL: 'Cile',
        CM: 'Camerun',
        CN: 'Cina',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Capo Verde',
        CY: 'Cipro',
        CZ: 'Repubblica Ceca',
        DE: 'Germania',
        DJ: 'Gibuti',
        DK: 'Danimarca',
        DM: 'Dominica',
        DO: 'Repubblica Dominicana',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egitto',
        EH: 'Sahara Occidentale',
        ER: 'Eritrea',
        ES: 'Spagna',
        ET: 'Etiopia',
        FI: 'Finlandia',
        FJ: 'Fiji',
        FK: 'Isole Falkland',
        FM: 'Micronesia',
        FO: 'Isole Faroe',
        FR: 'Francia',
        GA: 'Gabon',
        GB: 'Regno Unito',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'Guyana francese',
        GH: 'Ghana',
        GI: 'Gibilterra',
        GL: 'Groenlandia',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadalupa (francese)',
        GQ: 'Guinea Equatoriale',
        GR: 'Grecia',
        GS: 'Georgia del Sud e Isole Sandwich Meridionali',
        GT: 'Guatemala',
        GU: 'Guam (Stati Uniti)',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Isole Heard e McDonald',
        HN: 'Honduras',
        HR: 'Croazia',
        HT: 'Haiti',
        HU: 'Ungheria',
        ID: 'Indonesia',
        IE: 'Irlanda',
        IL: 'Israele',
        IN: 'India',
        IO: 'Territorio Britannico dell\'Oceano Indiano',
        IQ: 'Iraq',
        IR: 'Iran',
        IS: 'Islanda',
        IT: 'Italia',
        JM: 'Giamaica',
        JO: 'Giordania',
        JP: 'Giappone',
        KE: 'Kenya',
        KG: 'Kirghizistan',
        KH: 'Cambogia',
        KI: 'Kiribati',
        KM: 'Comore',
        KN: 'Saint Kitts e Nevis',
        KP: 'Corea del Nord',
        KR: 'Corea del Sud',
        KW: 'Kuwait',
        KY: 'Isole Cayman',
        KZ: 'Kazakistan',
        LA: 'Laos',
        LB: 'Libano',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Lituania',
        LU: 'Lussemburgo',
        LV: 'Lettonia',
        LY: 'Libia',
        MA: 'Marocco',
        MC: 'Monaco',
        MD: 'Moldavia',
        ME: 'Montenegro',
        MG: 'Madagascar',
        MH: 'Isole Marshall',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macao',
        MP: 'Isole Marianne Settentrionali',
        MQ: 'Martinica (francese)',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldive',
        MW: 'Malawi',
        MX: 'Messico',
        MY: 'Malesia',
        MZ: 'Mozambico',
        NA: 'Namibia',
        NC: 'Nuova Caledonia (francese)',
        NE: 'Niger',
        NF: 'Isola Norfolk',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Olanda',
        NO: 'Norvegia',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nuova Zelanda',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Perù',
        PF: 'Polinesia Francese',
        PG: 'Papua Nuova Guinea',
        PH: 'Filippine',
        PK: 'Pakistan',
        PL: 'Polonia',
        PM: 'Saint-Pierre e Miquelon',
        PN: 'Isole Pitcairn',
        PR: 'Porto Rico',
        PS: 'Palestina',
        PT: 'Portogallo',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Riunione (francese)',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russia',
        RW: 'Ruanda',
        SA: 'Arabia Saudita',
        SB: 'Isole Salomone',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Svezia',
        SG: 'Singapore',
        SH: 'Sant\'Elena',
        SI: 'Slovenia',
        SK: 'Slovacchia',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        SS: 'Sudan del Sud',
        ST: 'São Tomé e Príncipe',
        SV: 'El Salvador',
        SY: 'Siria',
        SZ: 'Swaziland',
        TC: 'Isole Turks e Caicos',
        TD: 'Chad',
        TF: 'Terre australi e antartiche francesi',
        TG: 'Togo',
        TH: 'Tailandia',
        TJ: 'Tagikistan',
        TK: 'Tokelau',
        TL: 'Timor Est',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turchia',
        TT: 'Trinidad e Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ucraina',
        UG: 'Uganda',
        UM: 'Isole Minori Esterne degli Stati Uniti',
        US: 'Stati Uniti d\'America',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Città del Vaticano',
        VC: 'Saint Vincent e Grenadine',
        VE: 'Venezuela',
        VG: 'Isole Vergini britanniche',
        VI: 'Isole Vergini americane',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Isole Wallis e Futuna',
        WS: 'Samoa',
        XK: 'Cossovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'Sudafrica',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: 'Arabo',
        bg: 'Bulgaro',
        cs: 'Ceco',
        da: 'Danese',
        de: 'Tedesco',
        el: 'Greco',
        'en-GB': 'Inglese (Regno Unito)',
        'en-US': 'Inglese',
        'es-ES': 'Spagnolo (Spagna)',
        es: 'Spagnolo',
        fi: 'Finlandese',
        'fr-CA': 'Francese canadese',
        fr: 'Francese',
        hr: 'Croato',
        hu: 'Ungherese',
        id: 'Indonesiano',
        is: 'Islandese',
        it: 'Italiano',
        iw: 'Ebraico',
        ja: 'Giapponese',
        ko: 'Coreano',
        lt: 'Lituano',
        ms: 'Malese',
        nl: 'Olandese',
        no: 'Norvegese',
        pl: 'Polacco',
        'pt-BR': 'Portoghese (Brasile)',
        pt: 'Portoghese',
        ro: 'Rumeno',
        ru: 'Russo',
        sk: 'Slovacco',
        sl: 'Sloveno',
        sr: 'Serbo',
        sv: 'Svedese',
        tr: 'Turco',
        'zh-HK': 'Cinese (Hong Kong)',
        zh: 'Cinese tradizionale',
    },
};
